import { Filter } from "@docma-mm-core/filter/filter";

export class LayoutFilter {

  constructor(init?: Partial<LayoutFilter> ) {
    if (init) {
      Object.assign(this, init);
      if (init.Filter) {
        this.Filter = new Filter(init.Filter);
      }
    }
  }

  Id?: number;
  LayoutId?: number;
  Filter?: Filter;

  IsAssigned?: boolean;
}
